module.exports = __webpack_public_path__ + "img/mini-intake-intro.b1375c86.png";